import { createSlice } from "@reduxjs/toolkit";
import shopService from "../services/allShops";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";

const initialState: any = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  allShops: [],
  shopDetail: {
    data: {},
    firestoreData: {},
    customerReturn: null,
  },
  category: null,
  isActive: null,
  isOpen: null,
  delivery: null,
  isFilterApplied: false,
  shopName: null,
  currentPage: 1,
};

const Slice: sagaSlice = createSlice({
  ...persist("allShopManagement", initialState),
  reducers: {
    ...createSagaReducer("fetchAllShops", "list"),
    updateShopCategory(state, action) {
      state.category = action.payload;
    },
    updateShopStatus(state, action) {
      state.isActive = action.payload;
    },
    updateShopOpen(state, action) {
      state.isOpen = action.payload;
    },
    updateDelivery(state, action) {
      state.delivery = action.payload;
    },
    updateShopDetails(state, action) {
      state.shopDetail.data = action.payload;
    },
    updateFirestoreData(state, action) {
      state.shopDetail.firestoreData = action.payload;
    },
    updateFilterButton(state, action) {
      state.isFilterApplied = action.payload;
    },
    updateShopName(state, action) {
      state.shopName = action.payload;
    },
    updateCustomerReturn(state, action) {
      state.shopDetail.customerReturn = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setAllShops(state, action) {
      state.allShops = action.payload;
    },
  },
});

const fetchAllShopsData = createAsyncSaga(
  "fetchAllShops",
  Slice,
  shopService.fetchAllShops,
  [
    "currentPage",
    "itemsPerPage",
    "category",
    "isActive",
    "isOpen",
    "delivery",
    "shopName",
  ]
);

addSaga(Slice.actions.fetchAllShops.type, fetchAllShopsData);

export const {
  fetchAllShops,
  updateShopCategory,
  updateShopStatus,
  updateShopOpen,
  updateDelivery,
  updateShopDetails,
  updateFirestoreData,
  updateFilterButton,
  updateShopName,
  updateCustomerReturn,
  setCurrentPage,
  setAllShops,
} = Slice.actions;

export default Slice.reducer;
